import React, { useEffect, useState } from "react";
import "./Style.css";
import { Apiurl, parseData } from "../../Pages/utils/page";
import axios from "axios";
import { NavLink } from "react-router-dom";
// import { url } from 'inspector';

const TopWinners = () => {
  const [TopWinnerData, setTopWinnerData] = useState([]);

  const GetTopWinner = () => {
    const loginToken = "";
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },
      url: `${Apiurl()}/api/Customer/GetTopWinner`,
    };
    axios(option)
      .then((e) => {
        setTopWinnerData(parseData(e.data.result));

        // setBuyItems(parseData(e?.data?.result))
      })
      .catch((error) => {});
  };
  useEffect(() => {
    GetTopWinner();
  }, []);
  return (
    <>
      {/* <div className="container mt-5">
                <div className="section_space">
                    <div className="row">
                        <div className='col-lg-12 col-12 mb_padding_0'>
                            <div className="TopWinners-main-container">
                          
                            <div className='TopWinners-heading-flex-section'><h3>Top Winners</h3> <div className='TopWinners-View-all-buttons'><span>View All</span></div></div>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div> */}

                <div className="save_baneer_scroll">
                  <div className="TopWinners-main-container">
                    <div className="TopWinners-heading-flex-section">
                      <h3>Top Winners</h3>
                      <NavLink to="/winning">
                        <div className="TopWinners-View-all-buttons">
                          <span>View All</span>
                        </div>{" "}
                      </NavLink>
                    </div>
                  </div>
                  <div className="AllWinner-flex-container">
                    {TopWinnerData?.map((winner, index) => {
                      const winnerImage = winner?.Image?.split('"');
                      const winnerImageUrl = `${Apiurl()}/${winnerImage?.[1]}`;
                      const bgColorClass =
                        index % 2 === 0 ? "bg-color-1" : "bg-color-2";

                      return (
                        // <div key={index} className="AllWinnerIMages">
                        <div
                          key={index}
                          className={`AllWinnerIMages ${bgColorClass}`}
                        >
                          {winnerImageUrl ? (
                            <img
                              src={
                                winnerImageUrl.includes("undefined")
                                  ? "/Images/unisexImage.jpeg"
                                  : winnerImageUrl
                              }
                              onError={(e) => {
                                e.target.onerror = null; // Prevent infinite loop
                                e.target.src = "/Images/unisexImage.jpeg";
                              }}
                            />
                          ) : null}
                          <div className="winer_name_display">
                            <p>{winner?.Name}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
            
         
    </>
  );
};

export default TopWinners;
